import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SpinnerComponent } from '@presencelearning/ui/spinner';

/** Same centered comet as the static boot loader in index.html. */
@Component({
  selector: 'app-boot-spinner',
  imports: [SpinnerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="pl-boot" role="status" aria-live="polite" aria-label="Loading">
      <pl-spinner [loading]="true" />
    </div>
  `,
})
export class BootSpinnerComponent {}
